import { NAV_INITIALIZE, NAV_ITEM_COUNT } from "../types";

export const navInitialize = stickyNav => ({
  type: NAV_INITIALIZE,
  stickyNav
});

export const navItemCountChanged = stickyNav => ({
  type: NAV_ITEM_COUNT,
  stickyNav
});

export const stickyNavInitialize = stickyNav => dispatch => {
  dispatch(navInitialize(stickyNav));
};

export const stickyNavInitializeContext = stickyNav => dispatch => {
  dispatch(navItemCountChanged(stickyNav));
};

export const stickyNavItemCountChanged = stickyNav => dispatch => {
  dispatch(navInitialize(stickyNav));
};



// WEBPACK FOOTER //
// ./src/actions/stickyNavAction.js